import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  BoxProps,
  Center,
  StyleProps,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { isDev } from "shared/utils/DevUtils";

const CautionTape: React.FC<BoxProps> = (props) => (
  <Box
    zIndex={99}
    height="6px"
    // https://stripesgenerator.com/
    bgSize="35.99px 34.75px"
    bgImage={`
      linear-gradient(
        136deg,
        var(--chakra-colors-gray-500) 30%,
        var(--chakra-colors-yellow-200) 30%,
        var(--chakra-colors-yellow-200) 50%,
        var(--chakra-colors-gray-500) 50%,
        var(--chakra-colors-gray-500) 80%,
        var(--chakra-colors-yellow-200) 80%,
        var(--chakra-colors-yellow-200) 100%);
    `}
    {...props}
  />
);

export const DeveloperZone: React.FC<React.PropsWithChildren<StyleProps>> = ({
  children,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  return isDev ? (
    <Accordion
      position="fixed"
      bottom="24px"
      left="24px"
      minWidth="200px"
      allowToggle={true}
      sx={{
        ".chakra-collapse": {
          // avoid changing size when opening/closing
          display: "block !important",
        },
      }}
      {...props}
    >
      <AccordionItem borderWidth={1} borderColor="yellow.200">
        <AccordionButton
          minHeight={0}
          p={0}
          flexDirection="column"
          alignItems="stretch"
          bg="yellow.200"
          _hover={{}}
        >
          <CautionTape />
          <Text
            px={4}
            py={1}
            color="gray.500"
            fontWeight="bold"
            textTransform="uppercase"
          >
            {t("common:developerZone")}
          </Text>
          <CautionTape marginBottom="-6px" />
        </AccordionButton>
        <AccordionPanel p={0}>
          <Center p="24px" bg="white">
            {children}
          </Center>
        </AccordionPanel>
        <CautionTape />
      </AccordionItem>
    </Accordion>
  ) : null;
};
